import axios from "axios";

let wpBaseUrl =
    process && process.env.REACT_APP_WP_REST_API_PATH
        ? process.env.REACT_APP_WP_REST_API_PATH
        : "";

let deploy_env = window.deploy_env ? window.deploy_env : false;

const wpHttp = axios.create({
    baseURL:
        deploy_env && deploy_env.WP_REST_API_PATH
            ? deploy_env.WP_REST_API_PATH
            : wpBaseUrl
});

export default wpHttp;
